import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faSliders,faPhotoFilm,faCheck,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh ,faBus, faMapLocationDot, faBolt, faRulerVertical, faSquareArrowUpRight,faArrowRight,faChevronDown,faMessage, faChevronUp, faFlag,faMicrophone, faTicket} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin, } from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import { useEffect } from 'react'
import PackageSlider from "./Component/PackageSlider";
import OBookingform from "./Component/obookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "4 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Peak & Safaris",
    location: "Nepal",
    days: "6 Days",
    difficulty: "Easy",
    price: 1150,
    duration: "6 Days",
    image: "/img/capital/nagarkot.webp",
    link: "/kathmandu-chitwan-nagarkot"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "14 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/company/mewith.jpeg",
  "/img/capital/myself.jpg",
 "/img/company/me1dslr.jpeg",
  "/img/capital/swyambhunath.webp",
  "/img/capital/swoyambhunath.JPG",
  "/img/capital/bouddha.webp",
  "/img/company/medslr.jpeg",
  "/img/capital/kathmandu2.jpg",
];
const OneDayKathmanduTour = () => {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [count,Setcount]=useState(1);
  const getmul=(qty)=>{
if(qty===1)return 140;
if(qty===2)return 100;
if(qty===3)return 90;
if(qty===4 )return 80;
if(qty>=5)return 70;
};
const totalprice =count*getmul(count);
const [opent, seT] = useState(false);
const [opente, seTe] = useState(false);
const [openr, seTr] = useState(false);
  useEffect(()=>{
    if(opent){
      document.body.style.overflow='hidden';
    }
    else{
      document.body.style.overflow='unset';
    }
    return()=>{
      document.body.style.overflow='unset';
    }
  },[opent]);
  

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  
  const [day1Open, setDay1Open] = useState(false);
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">The Big Four</h1>

    <div className="breadcrumb">
      <span>4 Unesco Heritage Sites Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/capital/pro.png" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>
        </div>


        <div className="everest-half">
            <div className="image-box"> <img src="/img/capital/swyambhunathdslr.jpeg" alt="error" /></div>
            <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />

      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>6 Hours</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Whole Year</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Vehical</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Historical, Cultural, and Religious</p>
          </div>
        </div>

         <div className="grid-item">
          <FontAwesomeIcon icon={faFlag}/>
          <div className="grid-item-next">
            <p className='Dur'>Kathmandu</p>
            <p className='Duration'>4 Unesco Heritage Sites</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faTicket}/>
          <div className="grid-item-next">
            <p className='Dur'>All Entry Fee</p>
            <p className='Duration'>Included</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faRulerVertical}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>4429 Ft</p>
          </div>
        </div>

      </div>

       </div>
       <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>

  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Visit 4 UNESCO World Heritage Sites.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Hear the stories that Google won't tell you.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Experience both Hindu and Buddhist traditions in one day.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Panoramic views of the entire valley.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> We handle the traffic and the tickets; you enjoy the views.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Exploring Traditional Newari Craftsmanship.</p>
  </div>
</div>
       <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
  Are you short on time but want to see the best of Nepal’s capital? Our One Day Kathmandu Tour is designed to show you the soul of this ancient city. In just 8 hours, you will explore four UNESCO World Heritage sites that blend history, spirituality, and incredible architecture.Whether you are seeking spiritual peace or architectural wonder, this journey offers a soulful look into the four crown jewels of Nepal’s capital—all in a single, unforgettable day.
  </div>
  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Swayambhunath (Monkey Temple):</b> Ancient hilltop stupa with panoramic city views.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Kathmandu Durbar Square:</b> The historic seat of royalty and the living Goddess Kumari.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Boudhanath Stupa:</b> One of the largest spherical stupas in the world.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Pashupatinath Temple:</b> Nepal’s most sacred Hindu temple and cremation site.</p>
  </div>
  <div className="heading smalling">Introduction Of Places</div>
 <p className='overview-text'><b>Swayambhunath: The All-Seeing Eyes</b> High on a hill, ancient eyes watch over the entire valley. Legend says this place was born from a lotus flower before the city even existed. You will walk among hundreds of monkeys and spinning wheels to find a view that feels like the top of the world. What you see here will stay with you forever.</p>
<p className='overview-text'><b>Boudhanath: The Giant Circle</b> This is one of the biggest stupas in the world, built like a giant meditation map. The air is thick with the smell of butter lamps and the sound of monks chanting. Thousands of people walk in a circle here every day, but the peace you feel inside is a secret you have to experience yourself.</p>
<p className='overview-text'><b>Kathmandu Durbar Square: Home of the Living Goddess</b> Walk through the old royal gates where kings were once crowned. Hidden inside a carved wooden palace lives a real young girl worshipped as a Living Goddess. The temples here are covered in carvings that tell stories from thousands of years ago. It feels like walking through a history book that is still alive.</p>
<p className='overview-text'><b> Pashupatinath: The Holy River Temple</b> This is the most sacred place for Hindus in Nepal, sitting right on the edge of a holy river. You will see golden roofs, wandering holy men, and ancient fire rituals that have not stopped for centuries. It is a powerful place that shows you the true meaning of life and tradition.</p>
</div>
<div className="overview-container">
  <div className="overview-heading">Why This Package ?</div>
 <p className='overview-text'>With so many ways to see the city, here is why travelers trust us to show them the best of Kathmandu:</p>
 <div className="heading smalling">Maximize Your Time</div>
 <p className='overview-text'>Kathmandu’s traffic can be tricky. Our expert drivers know the best routes and shortcuts, ensuring you spend your time at the monuments, not stuck in a car.</p>
 <div className="heading smalling">Deep Cultural Insights</div>
 <p className='overview-text'>Don't just look at old buildings. Our certified Professional Tour guides explain the why behind the rituals at Pashupatinath and the how behind the carvings at Durbar Square.</p>
 <div className="heading smalling">A "Stress-Free" Experience</div>
 <p className='overview-text'>We handle the logistics—from hotel pickup and drop-off to navigating the busy squares. All you need to do is bring your camera and enjoy the journey.</p>
 <div className="heading smalling">The Perfect Mix of Faiths</div>
 <p className='overview-text'>Our itinerary is carefully balanced to show you the harmony between Hinduism and Buddhism, giving you a complete spiritual picture of Nepal in just 6 hours.</p>
 <div className="heading smalling">Hidden Gems & Local Secrets</div>
 <p className='overview-text'>Beyond the main shrines, we’ll show you the best rooftop cafes for a view of Boudhanath and the quietest corners of the Monkey Temple for the perfect photo.</p>
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  <div className="timeline-row">
        <div className="timeline-left">
          <div className="day-circle">Day 1</div>
          {/* <div className="vertical-dots"></div> */}
        </div>

        <div
          className="timeline-right"
          onClick={() => setDay1Open(!day1Open)}
        >
         
          <div className="timeline-title">
          The Heart of the Himalayas in 6 Hours
          </div>

          <div className="arrow-icon">
            <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
          </div>
        </div>
      </div>

      {day1Open && (
        <div className="timeline-detail">
         9:00 AM – Kathmandu Durbar Square: Start your morning in the heart of the old city. Explore ancient palaces, marvel at hand-carved wooden temples, and visit the home of the Living Goddess (Kumari).

11:00 AM – Pashupatinath Temple: Visit Nepal’s most sacred Hindu site on the banks of the Bagmati River. You’ll see beautiful golden architecture, meet colorful holy men, and witness ancient spiritual rituals.

1:00 PM – Boudhanath Stupa: Head to one of the world's largest Buddhist stupas for lunch. Join the locals in a peaceful walk around the massive white dome and enjoy a meal at a rooftop café with a stunning view.

3:30 PM – Swayambhunath (Monkey Temple): End your day on a hilltop overlooking the entire valley. Watch the playful monkeys, spin the prayer wheels, and enjoy a 360-degree sunset view of the city.<br></br>
<b>Lunch Break</b>: Our sightseeing itinerary includes (45 min) lunch break, and we are flexible in allowing you to choose your restaurant for the Lunch.
        </div>
      )}

 
</div>
<div className="overview-container width-hund"id='included'>

<div className="cost-box included">
        <div className="cost-title">Cost Included</div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">
          Pick Up and Drop with private vehicle is included in this price.
          </div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">A Professional native language speaking tour guide.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">Temple and monastery entry permit fees.</div>
        </div>
        <div className="cost-item">
          <div className="icon-circle green">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="cost-text">All kind of service charge and Tax is included.</div>
        </div>
      </div>



      {/* COST EXCLUDED */}
      <div className="cost-box excluded">
        <div className="cost-title">Cost Not Included</div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Accommodation in Kathmandu is not Included</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Lunch is not Included.</div>
        </div>

        <div className="cost-item">
          <div className="icon-circle red">
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <div className="cost-text">Your Expenses like Tips,Purchasing local Product and things are also not Included.</div>
        </div>
      </div>

</div>
<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Reserve now & pay later
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
                There is no need of advanced payment to book this package you can directly pay to your guide before trip starts.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details or from contact us page where is a QR for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
               Ideal for history buffs, photography enthusiasts, and transit travelers with a 24-hour layover. Not recommended for those with significant mobility issues due to uneven temple steps.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies also Cancel up to 24 hours in advance for a full refund but for this package you don't need to pay for booking so there is free cancellation.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
   <p style={{padding:"4px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Walking Shoes:</b> You will be on your feet on cobblestones.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Sun Protection:</b> Hat, sunscreen, and sunglasses for open courtyards.</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Power Bank:</b> Your camera will be working overtime!</p>
   <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'24px'}}/> <b>Small Cash:</b> For tipping.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
                We stop in Bhaktapur, famous for its rooftop cafes overlooking the Nyatapola Temple. You can enjoy authentic Juju Dhau (King Curd) which is included in this package and (Our Suggestion) traditional Newari sets or standard Continental/Indian fare.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
    "This was hands-down the highlight of our trip to Nepal! Seeing all four major UNESCO sites in one day seemed ambitious, but our guide made it feel effortless. The contrast between the spiritual atmosphere at the Pashupatinath cremation ghats and the peaceful energy at the Boudhanath stupa was incredible. We learned so much about the intersection of Hinduism and Buddhism in the Valley. If you only have one day in Kathmandu, this tour is an absolute must-do!"
    </div>

    <div className="review-user">
      <div className="user-avatar">D</div>
      <div className="user-info">
        <div className="user-name">David S.</div>
        <div className="user-country">United States</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
    "非常震撼的一天！(A truly powerful day!) 导游非常专业，详细讲解了加德满都王宫广场的历史和杜巴广场的建筑艺术。我们特别喜欢猴庙（Swayambhunath），从山顶俯瞰整个城市的景色美得令人窒息。在大佛塔（Boudhanath）转经的感觉非常神圣。行程安排得很好，司机驾驶技术也很稳，非常推荐给想在短时间内了解尼泊尔文化的朋友。"
    </div>

    <div className="review-user">
      <div className="user-avatar">L</div>
      <div className="user-info">
        <div className="user-name">Li Wei (李伟)</div>
        <div className="user-country">China</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
    "A really solid day out exploring the 'Big Four'. The historical depth of Kathmandu Durbar Square is fascinating, and the architecture is unlike anything else I've seen. We particularly enjoyed the walk around Swayambhunath; the monkeys are quite a character! The only reason for four stars instead of five was the traffic in the city, which made the transit between sites a bit long, but that’s just the nature of Kathmandu. The sites themselves were spectacular and well worth the visit."
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sarah Jenkins</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book"onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text" >Book Now</div>
</div>

<div className="cta-button customize"onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review"onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$140</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon> Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                  <h6>See Terms & Condition</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
    </div>
     </section>
     {opent &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <OBookingform src="/img/capital/swyambhunathdslr.jpeg" title="The Big Fours"/></section>)}
{opente &&( <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/capital/swyambhunathdslr.jpeg" title="The Big Fours"/></section>)}
{openr &&( <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>)}
   </main>
  )
}
export default OneDayKathmanduTour